// extracted by mini-css-extract-plugin
export var buttons = "bp_cp";
export var current = "bp_ft";
export var image = "bp_k";
export var marker = "bp_fs";
export var markers = "bp_fr";
export var p = "bp_dQ";
export var promotions = "bp_fv";
export var section = "bp_j";
export var textContainer = "bp_bV";